import { render, staticRenderFns } from "./ser_bug.vue?vue&type=template&id=67b6714e&scoped=true&"
import script from "./ser_bug.vue?vue&type=script&lang=js&"
export * from "./ser_bug.vue?vue&type=script&lang=js&"
import style0 from "./ser_bug.vue?vue&type=style&index=0&id=67b6714e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b6714e",
  null
  
)

export default component.exports